import { render, staticRenderFns } from "./Crown.vue?vue&type=template&id=1476ecd8&scoped=true&"
import script from "./Crown.vue?vue&type=script&lang=js&"
export * from "./Crown.vue?vue&type=script&lang=js&"
import style0 from "./Crown.vue?vue&type=style&index=0&id=1476ecd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1476ecd8",
  null
  
)

component.options.__file = "Crown.vue"
export default component.exports